import { FC } from "react";
import styles from "./Switch.module.scss";

interface ISwitchProps {
    isEnabled: boolean;
    setIsEnabled: (isAvailable: boolean) => void;
    label: string;
    alwaysActiveColor?: boolean;
    isSelector?: boolean;
}

export const Switch: FC<ISwitchProps> = ({ 
    label, 
    isEnabled, 
    setIsEnabled,
    alwaysActiveColor = false,
    isSelector = false,
}) => {
    return (
        <div className={styles.switchContainer}>
            <span className={styles.label} onClick={ () => isSelector ? setIsEnabled(false) : null }>{label}</span>
            <div
                className={`${styles.switch} ${isEnabled ? styles.active : ""} ${
                    alwaysActiveColor ? styles.alwaysActive : ""
                }`}
                onClick={() => setIsEnabled(!isEnabled)}
            >
                <div className={`${styles.slider} ${isEnabled ? styles.active : ""}`} />
            </div>
        </div>
    );
};